var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container-fluid" }, [
    _vm.isMessage
      ? _c(
          "div",
          {
            staticClass: "alert alert-danger alert-margin",
            attrs: { role: "alert" },
          },
          [_vm._v(" " + _vm._s(_vm.message) + " ")]
        )
      : _vm._e(),
    _c("div", { staticClass: "row", attrs: { id: "title" } }, [
      _c("div", { staticClass: "col-1" }, [
        _c(
          "svg",
          {
            staticClass: "bd-placeholder-img mr-2 rounded",
            attrs: {
              id: "header",
              width: "28",
              height: "28",
              xmlns: "http://www.w3.org/2000/svg",
              preserveAspectRatio: "xMidYMid slice",
              focusable: "false",
              role: "img",
              "aria-label": "Placeholder: 32x32",
            },
          },
          [
            _c("rect", {
              attrs: { width: "100%", height: "100%", fill: "#00C3E0" },
            }),
          ]
        ),
      ]),
      _vm._m(0),
    ]),
    _c("div", { staticClass: "row", attrs: { id: "register_form" } }, [
      _c("div", { staticClass: "col-1" }),
      _c("div", { staticClass: "col-8" }, [
        _c(
          "form",
          {
            on: {
              submit: function ($event) {
                $event.preventDefault()
                return _vm.submit.apply(null, arguments)
              },
            },
          },
          [
            _c("div", { staticClass: "form-group" }, [
              _c("div", { staticClass: "row" }, [
                _vm._m(1),
                _c("div", { staticClass: "col-2" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.passwordPolicy.minimumLength,
                        expression: "passwordPolicy.minimumLength",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: {
                      type: "number",
                      required: "",
                      min: "6",
                      max: "20",
                    },
                    domProps: { value: _vm.passwordPolicy.minimumLength },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.passwordPolicy,
                          "minimumLength",
                          $event.target.value
                        )
                      },
                    },
                  }),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "form-group" }, [
              _c("div", { staticClass: "row" }, [
                _vm._m(2),
                _c("div", { staticClass: "col-2" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.passwordPolicy.requireUpperCase,
                        expression: "passwordPolicy.requireUpperCase",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: { type: "checkbox" },
                    domProps: {
                      checked: Array.isArray(
                        _vm.passwordPolicy.requireUpperCase
                      )
                        ? _vm._i(_vm.passwordPolicy.requireUpperCase, null) > -1
                        : _vm.passwordPolicy.requireUpperCase,
                    },
                    on: {
                      change: [
                        function ($event) {
                          var $$a = _vm.passwordPolicy.requireUpperCase,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(
                                  _vm.passwordPolicy,
                                  "requireUpperCase",
                                  $$a.concat([$$v])
                                )
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  _vm.passwordPolicy,
                                  "requireUpperCase",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(
                              _vm.passwordPolicy,
                              "requireUpperCase",
                              $$c
                            )
                          }
                        },
                        _vm.changeBelongs,
                      ],
                    },
                  }),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "form-group" }, [
              _c("div", { staticClass: "row" }, [
                _vm._m(3),
                _c("div", { staticClass: "col-2" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.passwordPolicy.requireLowerCase,
                        expression: "passwordPolicy.requireLowerCase",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: { type: "checkbox" },
                    domProps: {
                      checked: Array.isArray(
                        _vm.passwordPolicy.requireLowerCase
                      )
                        ? _vm._i(_vm.passwordPolicy.requireLowerCase, null) > -1
                        : _vm.passwordPolicy.requireLowerCase,
                    },
                    on: {
                      change: [
                        function ($event) {
                          var $$a = _vm.passwordPolicy.requireLowerCase,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(
                                  _vm.passwordPolicy,
                                  "requireLowerCase",
                                  $$a.concat([$$v])
                                )
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  _vm.passwordPolicy,
                                  "requireLowerCase",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(
                              _vm.passwordPolicy,
                              "requireLowerCase",
                              $$c
                            )
                          }
                        },
                        _vm.changeBelongs,
                      ],
                    },
                  }),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "form-group" }, [
              _c("div", { staticClass: "row" }, [
                _vm._m(4),
                _c("div", { staticClass: "col-2" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.passwordPolicy.requireDigits,
                        expression: "passwordPolicy.requireDigits",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: { type: "checkbox" },
                    domProps: {
                      checked: Array.isArray(_vm.passwordPolicy.requireDigits)
                        ? _vm._i(_vm.passwordPolicy.requireDigits, null) > -1
                        : _vm.passwordPolicy.requireDigits,
                    },
                    on: {
                      change: [
                        function ($event) {
                          var $$a = _vm.passwordPolicy.requireDigits,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(
                                  _vm.passwordPolicy,
                                  "requireDigits",
                                  $$a.concat([$$v])
                                )
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  _vm.passwordPolicy,
                                  "requireDigits",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(_vm.passwordPolicy, "requireDigits", $$c)
                          }
                        },
                        _vm.changeBelongs,
                      ],
                    },
                  }),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "form-group" }, [
              _c("div", { staticClass: "row" }, [
                _vm._m(5),
                _c("div", { staticClass: "col-2" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.passwordPolicy.requireSpecialChars,
                        expression: "passwordPolicy.requireSpecialChars",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: { type: "checkbox" },
                    domProps: {
                      checked: Array.isArray(
                        _vm.passwordPolicy.requireSpecialChars
                      )
                        ? _vm._i(_vm.passwordPolicy.requireSpecialChars, null) >
                          -1
                        : _vm.passwordPolicy.requireSpecialChars,
                    },
                    on: {
                      change: [
                        function ($event) {
                          var $$a = _vm.passwordPolicy.requireSpecialChars,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(
                                  _vm.passwordPolicy,
                                  "requireSpecialChars",
                                  $$a.concat([$$v])
                                )
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  _vm.passwordPolicy,
                                  "requireSpecialChars",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(
                              _vm.passwordPolicy,
                              "requireSpecialChars",
                              $$c
                            )
                          }
                        },
                        _vm.changeBelongs,
                      ],
                    },
                  }),
                ]),
              ]),
            ]),
            _c(
              "button",
              {
                staticClass: "btn btn-info btn btn-block",
                attrs: { id: "submit", type: "submit" },
              },
              [_vm._v(_vm._s(_vm.submitButtonText))]
            ),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-5" }, [
      _c("h5", [_vm._v("パスワードポリシー設定")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-10 label-container" }, [
      _c("label", { staticClass: "label-content" }, [_vm._v("最小桁数")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-10 label-container" }, [
      _c("label", { staticClass: "label-content" }, [_vm._v("英字（大文字）")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-10 label-container" }, [
      _c("label", { staticClass: "label-content" }, [_vm._v("英字（小文字）")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-10 label-container" }, [
      _c("label", { staticClass: "label-content" }, [_vm._v("数字")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-10 label-container" }, [
      _c("label", { staticClass: "label-content" }, [
        _vm._v("特殊文字（使用可能な文字： @/:~?!#%$）"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }